/* tslint:disable */
/* eslint-disable */
/**
 * AS3.Portals
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CourseExperience } from './CourseExperience';
import {
    CourseExperienceFromJSON,
    CourseExperienceFromJSONTyped,
    CourseExperienceToJSON,
} from './CourseExperience';
import type { EducationExperience } from './EducationExperience';
import {
    EducationExperienceFromJSON,
    EducationExperienceFromJSONTyped,
    EducationExperienceToJSON,
} from './EducationExperience';
import type { VolunteerExperience } from './VolunteerExperience';
import {
    VolunteerExperienceFromJSON,
    VolunteerExperienceFromJSONTyped,
    VolunteerExperienceToJSON,
} from './VolunteerExperience';
import type { WorkExperience } from './WorkExperience';
import {
    WorkExperienceFromJSON,
    WorkExperienceFromJSONTyped,
    WorkExperienceToJSON,
} from './WorkExperience';

/**
 * 
 * @export
 * @interface Experience
 */
export interface Experience {
    /**
     * 
     * @type {Array<WorkExperience>}
     * @memberof Experience
     */
    workExperiences?: Array<WorkExperience>;
    /**
     * 
     * @type {Array<EducationExperience>}
     * @memberof Experience
     */
    educations?: Array<EducationExperience>;
    /**
     * 
     * @type {Array<CourseExperience>}
     * @memberof Experience
     */
    courses?: Array<CourseExperience>;
    /**
     * 
     * @type {Array<VolunteerExperience>}
     * @memberof Experience
     */
    volunteerExperiences?: Array<VolunteerExperience>;
}

/**
 * Check if a given object implements the Experience interface.
 */
export function instanceOfExperience(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExperienceFromJSON(json: any): Experience {
    return ExperienceFromJSONTyped(json, false);
}

export function ExperienceFromJSONTyped(json: any, ignoreDiscriminator: boolean): Experience {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'workExperiences': !exists(json, 'WorkExperiences') ? undefined : ((json['WorkExperiences'] as Array<any>).map(WorkExperienceFromJSON)),
        'educations': !exists(json, 'Educations') ? undefined : ((json['Educations'] as Array<any>).map(EducationExperienceFromJSON)),
        'courses': !exists(json, 'Courses') ? undefined : ((json['Courses'] as Array<any>).map(CourseExperienceFromJSON)),
        'volunteerExperiences': !exists(json, 'VolunteerExperiences') ? undefined : ((json['VolunteerExperiences'] as Array<any>).map(VolunteerExperienceFromJSON)),
    };
}

export function ExperienceToJSON(value?: Experience | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'WorkExperiences': value.workExperiences === undefined ? undefined : ((value.workExperiences as Array<any>).map(WorkExperienceToJSON)),
        'Educations': value.educations === undefined ? undefined : ((value.educations as Array<any>).map(EducationExperienceToJSON)),
        'Courses': value.courses === undefined ? undefined : ((value.courses as Array<any>).map(CourseExperienceToJSON)),
        'VolunteerExperiences': value.volunteerExperiences === undefined ? undefined : ((value.volunteerExperiences as Array<any>).map(VolunteerExperienceToJSON)),
    };
}

